import differenceInYears from 'date-fns/differenceInYears';
import parse from 'date-fns/parse';

import { formatDatyBackend } from '~/terminy.config';

export const prepareCenaParam = (Cena: Array<string>): string => {
  let cenaParam = `&cena=${Cena[0]}`;

  if (Cena[1]) {
    const cenaOdDo = Cena[1].split('-');

    cenaParam += `&cena.od=${cenaOdDo[0]}&cena.do=${cenaOdDo[1]}`;
  }

  return cenaParam;
};

export const prepareDlugoscPobytuParam = (DlugoscPobytu: Array<string>): string => {
  if (!DlugoscPobytu[1]) return '';

  let dlugoscPobytuParam = `&dlugoscPobytu=${DlugoscPobytu[1]}`;

  if (DlugoscPobytu[0]) {
    const dlugoscPobytuOdDo = DlugoscPobytu[0].split('-');

    dlugoscPobytuParam += `&dlugoscPobytu.od=${dlugoscPobytuOdDo[0]}&dlugoscPobytu.do=${dlugoscPobytuOdDo[1]}`;
  }

  return dlugoscPobytuParam;
};

export const prepareDatyUrodzeniaParam = (DatyUrodzenia: Array<string>): { dorosli: Array<String>; dzieci: Array<String> } => {
  const dorosli: Array<string> = [];
  const dzieci: Array<string> = [];

  DatyUrodzenia.forEach((value) => {
    const personBrithDate = parse(value, formatDatyBackend, new Date());
    const today = new Date();
    const personAge = differenceInYears(today, personBrithDate);

    personAge >= 18 ? dorosli.push(value) : dzieci.push(value);
  });

  if (!dzieci.length) {
    dzieci.push('nie');
  }

  return { dorosli, dzieci };
};
